<template>
	<div v-loading="dataLoading">
		<template v-if="formData">
			<tab name="17">{{id}} {{formData.title}} </tab>
			<el-form :model="formData"  ref="formData" label-position="top" size="medium">
				<!-- <el-form-item prop="type" label="首页排序分权重：">
					<el-select v-model="formData.type" size="medium" placeholder="请选择">
						<el-option :value="1" label="加分"></el-option>
						<el-option :value="0" label="减分"></el-option>
					</el-select>
				</el-form-item> -->
				<el-card header="排序分权重分时段设置" class="MT20" shadow="hover">
					<table class="info-table" style="width:100%">
						<tr>
							<th>展示时间段</th>
							<th>分值选项</th>
							<th>分值</th>
						</tr>
						<tr v-for="(item,index) in formData.periodSetting" :key="index">
							<td>
								<el-form-item prop="time" :label=" '权重时间段' + `${index + 1 }`">
									<el-date-picker
										style="width: 49%;"
										v-model="item.startTime"
										type="datetime"
										placeholder="请选择开始时间"
										value-format="yyyy-MM-dd HH:mm:ss"
										size="small">
									</el-date-picker>
									<el-date-picker
										style="width: 49%; margin-left: 10px;"
										v-model="item.endTime"
										type="datetime"
										placeholder="请选择结束时间"
										value-format="yyyy-MM-dd HH:mm:ss"
										size="small">
									</el-date-picker>
								</el-form-item>
							</td>
							<td>										
								<el-select v-model="item.type" size="small" class="MT30">											
									<el-option :value="1" label="加分"></el-option>
									<el-option :value="2" label="减分"></el-option>
								</el-select>										
							</td>
							<td>
								<el-input-number v-model="item.score" controls-position="right" :min="0" :max="4000" size="small" :precision="0" placeholder="请输入1-4000的分值"
									style="width: 100%;" class="MT30"></el-input-number>
							</td>
						</tr>
					</table>
				</el-card>	
				<el-row :gutter="30" class="MT20">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="score">
							<span slot="label">分值：</span>
							<el-input-number v-model="formData.score" controls-position="right" :min="0" :max="4000" precision="0" placeholder="请输入1-4000的分值"
								style="width: 100%;" :disabled="true"></el-input-number>
							<div>
								<small class="color-warning">可输入1-4000的分值</small>
							</div>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="distanceScore" :rules="[{required: true, message: '请选择首页列表距离权限'}]">
							<span slot="label">首页列表距离权限：</span>
							<el-radio-group v-model="formData.distanceScore">
								<el-radio :label="1" border>开启 </el-radio>
								<el-radio :label="0" border>关闭 </el-radio>
							</el-radio-group>
							<div>
								<small class="color-warning">开启后演出在城市800KM以内均可在首页推荐出现</small>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="recommendReason">
							<span slot="label">首页锐评推荐理由：</span>
							<el-input v-model="formData.recommendReason" placeholder="请输入16字以内的推荐理由" maxlength="16" show-word-limit></el-input>
							<div>
								<small class="color-warning">输入的文案会在首页演出列表卡片的推荐理由区域展示</small>
							</div>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item >
							<span slot="label">首页锐评推荐展示时间：</span>
							<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
								end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
								:default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 演出详情试听：开启后演出艺人匹配到云音乐歌曲时在详情页展示试听播放 -->
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="thirdMusicStatus">
							<span slot="label">演出详情试听：</span>
							<el-radio-group v-model="formData.thirdMusicStatus">
								<el-radio :label="1" border>开启</el-radio>
								<el-radio :label="0" border>关闭</el-radio>
							</el-radio-group>
							<div>
								<small class="color-warning">开启后演出艺人匹配到云音乐歌曲时在详情页展示试听播放</small>
							</div>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="durationDisplayStatus">
							<span slot="label">演出详情演出时长展示：</span>
							<el-radio-group v-model="formData.durationDisplayStatus">
								<el-radio :label="1" border>开启</el-radio>
								<el-radio :label="0" border>关闭</el-radio>
							</el-radio-group>
							<div>
								<small class="color-warning">开启后接口返回计算的演出时长；关闭后演出详情页展示"演出时长以现场为准"</small>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>			
			<div class="MT20">
				<el-button @click="goBack">返回</el-button>
				<el-button v-if="$utils.have('/activity/getSortScore')" type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
			</div>
		</template>
	</div>
</template>

<script>
	const defaultData = {
	    type: 1, 
	    score: '',
		distanceScore:0,
		recommendReason:'',
		thirdMusicStatus: 1, // 演出详情试听开关 1:开启 0:关闭，默认开启
		durationDisplayStatus: 1, // 演出详情演出时长展示开关 1:开启 0:关闭，默认开启
		periodSetting:[
			{startTime:'',endTime:'',score:0,type:1},
			{startTime:'',endTime:'',score:0,type:1},
			{startTime:'',endTime:'',score:0,type:1}
		],
		recommendReasonStartTime:'',
		recommendReasonEndTime:''
	}
	import Tab from './components/tab'	
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			},
			
		},
		components: {
			Tab,
			
		},
		data() {
			return {
				formData: {...defaultData}, 
				dataLoading: false,				
				btnLoading: false,
				timeArray:[],
				datetimerange:[]
				
			}
		},
		created() {
			if (this.id) {
				this.getDataDetail();
			}
		},
	 
		methods: {
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/getSortScore",
						params: {
							activityId: parseInt(this.id)
						},
						method: "get",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result ) {
							 this.formData = {
								 ...result,
								 //演出详情演出时长展示兜底：旧数据接口未返回时默认开启
								 durationDisplayStatus: result.durationDisplayStatus != null ? result.durationDisplayStatus : 1,
								 periodSetting:result.periodSetting ? result.periodSetting : this.formData.periodSetting
							 }
							 this.datetimerange = result.recommendReasonStartTime && result.recommendReasonEndTime ? [result.recommendReasonStartTime,result.recommendReasonEndTime] : []
							 
						} else {
							this.$message.error(msg || "获取数据失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取数据失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},			
			// 检查时间是否有效的辅助函数
		    isValidTime(timeStr) {
		      return timeStr && timeStr.trim() !== '' && !isNaN(new Date(timeStr).getTime());
		    },
			//表单提交
			onSubmit() {
				var _message = ''
				
				if( this.datetimerange && this.datetimerange.length > 0 && !this.formData.recommendReason ){
					return this.$message.error("首页锐评推荐理由不能为空！");
				}
				this.formData.periodSetting.map((v, i) => {
					if( ( v.startTime && !v.endTime ) || ( !v.startTime  && v.endTime ) ){						
						_message = `时间段${i+1}: 开始时间和结束时间不能为空`;						
					}
				})
				if( _message !='' ){
					return this.$message.error(_message);			
				}
				const validTimes = this.formData.periodSetting.filter(item =>
				  this.isValidTime(item.startTime) && this.isValidTime(item.endTime)
				);
				
				if( validTimes ){
					var _compare = false,_compareMsg = ''
					validTimes.map((v, i) => {
						if (this.$utils.compareDate(v.startTime, v.endTime)) {
							_compare = true
						    _compareMsg = `时间段${i+1}: 开始时间必须小于结束时间`;				   
						}
						
					})
					if(_compare){
						return this.$message.error(_compareMsg);		
					}
				}
				if (validTimes.length  ==  0 ) {				
					this.formData.periodSetting = []
				}
				// 检查每对时间段是否重叠
				for (let i = 0; i < validTimes.length; i++) {
				  for (let j = i + 1; j < validTimes.length; j++) {
				    const timeA = validTimes[i];
				    const timeB = validTimes[j];
				    
				    const startA = new Date(timeA.startTime);
				    const endA = new Date(timeA.endTime);
				    const startB = new Date(timeB.startTime);
				    const endB = new Date(timeB.endTime);
				   
					
				    // 检查重叠条件：A的开始时间小于B的结束时间 且 A的结束时间大于B的开始时间
				    if (startA < endB && endA > startB) {
						var _msg = `发现时间交叉：时间段${i+1}和时间段${j+1}重叠`;
					  return this.$message.error(_msg);
				    }
				  }
				}
				this.$refs["formData"].validate((valid) => {
					if (valid) {
						this.$request({
								url: "/activity/sortScore",
								method: "POST",								
								data: {
								    ...this.formData,
								    activityId: this.id,
									recommendReasonStartTime: this.datetimerange && this.datetimerange[0] || '',
									recommendReasonEndTime: this.datetimerange && this.datetimerange[1] || '',
								},
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg
								} = res.data;
								if (state && state == 1) {
									this.$message.success("操作成功");
									this.getDataDetail()
								} else {
									return this.$message.error(msg || "操作失败");
								}
							})

					}
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	::v-deep .el-form--label-top .el-form-item__label{
		padding:0
	}
	::v-deep .el-form-item{
		margin-bottom: 10px;
	}
	.MT30{
		margin-top: 30px;
	}
	.font10 {
		font-size: 10px;
	}
	.info-table td {
		border-right: 1px solid #eee;
		padding-left:20px;
	}
	.info-table th {
		padding-left:20px;
	}
</style>